import { LinearGradient } from "expo-linear-gradient";
import React, { useEffect, useState } from 'react';
import { Text, TextInput, TouchableOpacity, View } from 'react-native';
import { Checkbox } from 'react-native-paper';
import { FormattedMessage } from 'react-intl';
import HeaderDefault from '../../components/HeaderDefault';

import styles from "./styles";

const SellExchange = ({ navigation, route }) => {
    const [checked, setChecked] = useState(false);
    const [qtd, setQtd] = useState(0);
    const [token, setToken] = useState(null);
    const [valueCoin, setValueCoin] = useState(0);

    useEffect(() => {
        setToken(route.params.token);
        setQtd(route.params.qtd);
        //   console.log(token)
    }, []);

    return (
        <>
            <FormattedMessage id="sellExchange.titleExchange">
                {titleExchange =>
            <HeaderDefault title={titleExchange} />}
            </FormattedMessage>

            <View style={styles.content}>
                <Text style={styles.titlePage}><FormattedMessage id="sellExchange.txtDefineQuantidade"/></Text>

                <View style={styles.contentAmount}>
                    <TextInput style={styles.textInputAmount} value={qtd} onChangeText={(e) => setQtd(e)} />
                    <Text style={styles.coin}>{token ? token.name_token : "GPX"}</Text>
                </View>

                <View style={styles.contentPriceSell}>
                    <Text style={styles.textInfoPriceSell}><FormattedMessage id="sellExchange.txtPrecoVenda"/></Text>
                    <TextInput style={styles.textInputPriceSell} value={valueCoin} onChangeText={(e) => setValueCoin(e)} />
                </View>

                <View style={styles.contentPrices}>
                    <Text style={styles.descriptionPrice}><FormattedMessage id="sellExchange.txtUltimoPreco"/><Text style={styles.price}><FormattedMessage id="sellExchange.txtNumGpx"/></Text>
                    </Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.descriptionPrice}><FormattedMessage id="sellExchange.txtPrecoCompra"/><Text style={styles.price}>{token ? token.single_value : "000.000,00"}<FormattedMessage id="sellExchange.txtGpx"/></Text>
                    </Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.descriptionPrice}><FormattedMessage id="sellExchange.txtPrecoMercado"/><Text style={styles.price}><FormattedMessage id="sellExchange.txtNumGpx"/></Text>
                    </Text>
                </View>
            </View>

            <View style={styles.contentCheckbox}>
                <Checkbox
                    status={checked ? 'checked' : 'indeterminate'}
                    onPress={() => {
                        setChecked(!checked);
                    }}
                />
                <Text><FormattedMessage id="sellExchange.txtVendePrecoMercado"/></Text>
            </View>

            <View style={styles.contentBtn}>
                <TouchableOpacity onPress={() => navigation.navigate('ConfirmPassword', { qtd: qtd, valueCoin: valueCoin, market: checked, purchase: false })}>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1, y: 0 }}
                        colors={["#196059", "#196059"]}
                        style={styles.btn}
                    >
                        <Text style={styles.textBtn}><FormattedMessage id="sellExchange.txtContinuar"/></Text>
                    </LinearGradient>
                </TouchableOpacity>
            </View>
        </>
    );
}

export default SellExchange;